import { render, staticRenderFns } from "./expensesJurManagement.vue?vue&type=template&id=43f0f96a&scoped=true"
import script from "./expensesJurManagement.vue?vue&type=script&lang=js"
export * from "./expensesJurManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0f96a",
  null
  
)

export default component.exports